import viewportHelper from '@/framework/helpers/viewport';

const Viewport = {
  install(Vue) {
    Vue.prototype.$viewport = viewportHelper;
  },
};

export default Viewport;
